import React from 'react';

interface Props {
    children?: any;
    tabNames: any;
    openTab: number | string;
    setOpenTab: (index: number) => void;
    className?: string;
    tabClassName?: string;
}

const Tabs: React.FC<Props> = ({
    children,
    tabNames,
    openTab,
    setOpenTab,
    className,
    tabClassName,
}) => {
    const defaultClasses =
        'group rounded flex-1 min-w-0 px-4 py-1 text-center text-sm text-[#131212] md:text-base hover:bg-[#f47d291a] whitespace-nowrap shrink-0 basis-auto';
    const activeClasses = 'bg-[#F47D29] font-bold cursor-default';
    const inactiveClasses = 'bg-transparent';
    const badgeClasses =
        'font-bold ml-2 inline-flex text-[12px]/[12px] rounded-full border border-[#131212] px-[4px] py-[1px] text-[#212B36] group-hover:bg-[#131212] group-hover:text-white';
    const badgeActiveClasses = 'bg-[#131212] text-white';

    const tabs = tabNames.map((tabInfo: any, index: number) => {
        index += 1;

        return (
            <button
                key={index}
                className={`${defaultClasses} ${tabClassName} ${
                    openTab === index ? activeClasses : inactiveClasses
                }`}
                onClick={() => setOpenTab(index)}
            >
                {tabInfo.name}
                {tabInfo?.count ? (
                    <div
                        className={`${badgeClasses} ${
                            openTab === index ? badgeActiveClasses : ''
                        }`}
                    >
                        {tabInfo.count}
                    </div>
                ) : (
                    ''
                )}
            </button>
        );
    });

    return (
        <>
            <div
                className={`mb-7.5 flex w-full flex-nowrap gap-2 overflow-x-auto rounded-lg bg-[#F47D29]/[.1] p-2 ${className}`}
            >
                {tabs}
            </div>

            {children}
        </>
    );
};

export default Tabs;
